import { callApi } from '../../client/apiToolbox';

export const callApiHooked = async (
  url,
  method,
  customHeaders = {},
  body,
  onSuccess,
  onFailure,
) => {
  try {
    const headers = { ...customHeaders, credentials: 'include' };
    if (body) {
      headers['Content-Type'] = 'application/json';
    }
    const res = await callApi(url, method, headers, body);
    if (!res.success) {
      if (!res.json) {
        throw Error('Internal server error');
      }
      throw res.json;
    }
    onSuccess(res.json);
  } catch (err) {
    onFailure(err);
  }
};
